import { IFeathersDefaultFilters, IFeathersResponse } from 'src/types/feathers.types'
import fetch from 'src/utils/fetchToken'
import fetchService from 'src/utils/fetchToken'
import { clientInfo } from './authMandat'

const CustomerEndpoint = `${process.env.REACT_APP_API_URL}/customers`

export interface newCustomerInfo {
  status?: string
  iban?: string
  bic?: string
}



export const sendNewInfo = async (clientId: number , newCustomerInfo: newCustomerInfo): Promise<IFeathersResponse<newCustomerInfo>> => {
  return fetch(`${CustomerEndpoint}/${clientId}`, 'PATCH', newCustomerInfo)
}

export const getCustomerByNumClient = async (numClient: string): Promise<IFeathersResponse<clientInfo>> => {
  return fetch(`${CustomerEndpoint}?num_client=${numClient}`, 'GET')
}

